import { createGrid, getDimensions, getTargetShape } from '../artwork'
import { setDebugText } from '../main'
import { CellState, DisplayState, GlobalState } from '../types'

export function initGlobalState(): GlobalState {
  const display = getDimensions()
  const canvas = document.getElementById('artwork') as HTMLCanvasElement
  if (canvas) {
    setDebugText(
      `${display.columns}&times;${display.rows} cells - ${canvas.width}&times;${canvas.height}px`
    )
  }
  const grid = createGrid(0, display.columns, display.rows)
  return {
    grid,
    display,
    animation: animationInitialValues(display)
  }
}

function animationInitialValues(display: DisplayState): CellState[] {
  const result: CellState[] = []
  const cellCount = display.rows * display.columns
  for (let i = 0; i < cellCount; i++) {
    result[i] = {
      color: [0, 0, 0],
      targetShape: getTargetShape(0),
      currentShape: getTargetShape(0),
      age: 0
    }
  }
  return result
}
